import styled from 'styled-components';

const Wrapper = styled.div`
    height: 100%;
    overflow: hidden;
    padding: 20px;
`;

export default Wrapper;
